export const MAX_FILE_SIZE_BYTES = 52428800 // 50MB
